import type { ReactElement } from 'react';

/** Banner "SANDBOX" (sección 5). Se pinta cuando settings/environment.env === 'sandbox'. */
export function SandboxBanner({ text }: { text: string }): ReactElement {
  return (
    <div
      role="status"
      style={{
        background: 'var(--nv-sandbox)',
        color: '#111',
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: '0.04em',
        textAlign: 'center',
        padding: '4px 16px',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
      }}
    >
      {text}
    </div>
  );
}
